import React, { useState, useEffect } from "react";
import { Eye } from "lucide-react";
import { api } from "@/lib/api";

// Subtle social-proof badge: real distinct sessions viewing this exact page in the last 20 min.
export function LiveViewers() {
  const [n, setN] = useState(0);
  useEffect(() => {
    let alive = true;
    const fetchN = () => api.get(`/stats/live-viewers?path=${encodeURIComponent(window.location.pathname)}`)
      .then(({ data }) => { if (alive) setN(data.viewers || 0); }).catch(() => {});
    fetchN();
    const t = setInterval(fetchN, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (n < 2) return null;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald bg-emerald/10 rounded-full px-3 py-1" data-testid="live-viewers">
      <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald opacity-70" /><span className="relative inline-flex rounded-full h-2 w-2 bg-emerald" /></span>
      <Eye size={13} /> {n} shopping now
    </span>
  );
}
